<template>
  <div class='body-box marginBox'>
    <el-row class='plan' :gutter="20">
      <el-col :span='24'>
        <el-tabs v-model="activeName" @tab-click="btnStatus">
          <el-tab-pane label="待确定" name="CONFIRM"></el-tab-pane>
          <el-tab-pane label="待出行" name="TRAVEL"></el-tab-pane>
          <el-tab-pane label="已取消" name="CANCEL"></el-tab-pane>
          <el-tab-pane label="已完成" name="END"></el-tab-pane>
          <el-tab-pane label="全部" name="ALL"></el-tab-pane>
        </el-tabs>
      </el-col>

      <el-col :span='5'>
        <search-input v-model="queryInfo.keyword" placeholder='酒店的名称/预约人' @change="handleQuery" />
      </el-col>
      <el-col :span='5'>
        <search-input v-model="queryInfo.orderNo" placeholder='订单号' @change="handleQuery"/>
      </el-col>
    </el-row>

    <el-table :height="'calc(100% - 120px)'" :data='orderList' class='button-box'>
      <el-table-column type='expand'>
        <template slot-scope='scope'>
          <el-table :data='scope.row.courtTime' style='padding-top: 10px;' class='button-box'>
            <el-table-column label='时间组数' prop='key' />
            <el-table-column label='打球日期' prop='date' />
            <el-table-column label='打球时间' prop='concreteTime' />
          </el-table>
          <el-table :data='scope.row.groupPerson' style='padding-top: 10px;' class='button-box'>
            <el-table-column label='打球组数' prop='type' />
            <el-table-column label='组数' prop='names' />
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label='酒店名称' prop='hotel' :show-overflow-tooltip='true' />
      <el-table-column label='球场名称' prop='title' :show-overflow-tooltip='true' />
      <el-table-column label='预订人' prop='userName' />
      <el-table-column label='标间数' prop='doubleNum' />
      <el-table-column label='单间数' prop='singleNum' />

      <el-table-column label='确认入住日期'>
        <template slot-scope='scope'>
          {{ scope.row.confirmEnterDate | formatDate('yyyy-MM-dd') }}
        </template>
      </el-table-column>
      <el-table-column label='确认离店日期' prop='enterDate'>
        <template slot-scope='scope'>
          {{ scope.row.confirmOutDate | formatDate('yyyy-MM-dd') }}
        </template>
      </el-table-column>


      <el-table-column label='入住日期' prop='enterDate'>
        <template slot-scope='scope'>
          {{ scope.row.enterDate | formatDate('yyyy-MM-dd') }}
        </template>
      </el-table-column>
      <el-table-column label='退房日期' prop='outDate'>
        <template slot-scope='scope'>
          {{ scope.row.outDate | formatDate('yyyy-MM-dd') }}
        </template>
      </el-table-column>
      <el-table-column label='是否支付' prop='enumPay'>
        <template slot-scope='scope'>
          {{ scope.row.enumPay | formatYESNo }}
        </template>
      </el-table-column>
      <el-table-column label='班车需要' prop='enumShuttle'>
        <template slot-scope='scope'>
          {{ scope.row.enumShuttle | formatYESNo }}
        </template>
      </el-table-column>
      <el-table-column label='订单状态'>
        <template slot-scope='scope'>{{ scope.row.enumStatus | orderStatus }}</template>
      </el-table-column>
      <el-table-column label='订单编号' prop='orderNo' :show-overflow-tooltip='true' />
      <el-table-column label='总金额' prop='cost' />
      <el-table-column label='发放确认书' prop='confirmation'>
        <template slot-scope='scope'>
          {{ scope.row.confirmation | formatConfirmation }}
        </template>
      </el-table-column>
      <el-table-column label='操作' min-width='100' fixed="right">
        <template slot-scope='scope'>
          <el-popover placement="right" trigger="click">
            <div class="foldBtnBox">
              <!--<div><el-button v-if="queryInfo.status === 'CONFIRM'" @click="decidedOrder(scope.row)">待确定</el-button></div>-->
              <div><el-button v-if="queryInfo.status === 'TRAVEL'" @click='decidedOrder(scope.row)'>发送确认书</el-button></div>
              <div><el-button @click='uploadPdf(scope.row)'>上传确认书</el-button></div>
              <div><el-button @click='getUserInfoByOrder(scope.row)'>查看下单用户信息</el-button></div>
              <div><el-button @click='updateTravelOrder(scope.row)'>修改订单</el-button></div>
              <div><el-button v-if="queryInfo.status === 'END'" @click='editOrder(scope.row)'>待积分</el-button></div>
              <div><el-button @click='openPlayTime(scope.row)'>修改时间</el-button></div>
              <div><el-button @click='openOrder(scope.row)'>修改状态</el-button></div>
              <div><modify-cost v-if="scope.row.enumStatus !== 'CANCEL'" :orderCost='scope.row.cost' :orderId='scope.row.orderId'
                                @change='handleQuery'></modify-cost></div>
              <div><delete-order :orderId='scope.row.orderId' orderType='TRAVEL' @change='handleQuery'></delete-order></div>
            </div>
            <el-button slot="reference">更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <!--发送邮件-->
    <sendmail ref='sendmail'></sendmail>
    <!--单独上传PDF-->
    <uploadPdf ref='uploadPdf'></uploadPdf>
    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref='page' :query-param.sync='queryInfo' @pagination='getOrderList'></pagination></div>

    <!--修改状态对话框-->
    <el-dialog title='确认订单' :visible.sync='dialogVisibleDecidedOrder' width='30%'>
      <el-form label-width='80px'>
        <el-row>
          <el-col :span='24'>
            <el-form-item label='是否支付'>
              <el-input></el-input>
            </el-form-item>
          </el-col>

          <el-col :span='24'>
            <el-form-item label='修改状态'>
              <el-input></el-input>
            </el-form-item>
          </el-col>

          <el-col :span='24'>
            <el-form-item label='发送确认书'>
              <el-input></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='dialogVisibleDecidedOrder = false'>取 消</el-button>
        <el-button type='primary' @click='dialogVisibleDecidedOrder = false'>确 定</el-button>
      </span>
    </el-dialog>

    <!--查看打球人-->
    <el-dialog title='查看打球人' :visible.sync='dialogVisible' width='30%'>
      <div v-for='(item, index) in valList' :key='index' class='plo'>
        <span>第{{ item.key }}组  :  </span>
        <span>{{ item.plo }}</span>
      </div>
    </el-dialog>

    <!--修改状态-->
    <modify-order @refresh-list='handleQuery' ref='modifyOrder'></modify-order>
    <!--获取用户信息-->
    <user-info ref='getUserInfo'></user-info>

    <el-dialog title='修改时间' :visible.sync='dialogPlayBallTime' width='30%'>
      <el-form label-width='100px'>
        <el-form-item label='入住日期'>
          <el-date-picker v-model='playBallTime.confirmEnterDate' type='date' value-format='timestamp'
                          placeholder='选择日期'
                          style='width: 100%;'></el-date-picker>
        </el-form-item>

        <el-form-item label='退房日期'>
          <el-date-picker v-model='playBallTime.confirmOutDate' type='date' value-format='timestamp' placeholder='选择日期'
                          style='width: 100%;'></el-date-picker>
        </el-form-item>
        <el-form-item label='打球日期' v-for='item in courtTime' :key='item.key'>
          <el-date-picker v-model='item.date' format='yyyy 年 MM 月 dd 日'
                          value-format='yyyy-MM-dd' type='date' placeholder='选择日期'
                          style='width: 100%;'></el-date-picker>
          <el-time-select
            style='width:48%;margin-top:10px'
            v-model='item.startTime'
            :picker-options="{
              start: '05:00',
              step: '00:01',
              end: '14:00'
            }"
            placeholder='选择时间'>
          </el-time-select>
          <el-time-select
            style='width: 48%;margin-left: 14px;margin-top:10px'
            v-model='item.endTime'
            :picker-options="{
              start: '05:00',
              step: '00:01',
              end: '14:00'
            }"
            placeholder='选择时间'>
          </el-time-select>
        </el-form-item>
      </el-form>

      <span slot='footer' class='dialog-footer'>
        <el-button @click='dialogPlayBallTime = false'>取 消</el-button>
        <el-button type='primary' @click='modifyStadiumOrder'>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getData, getPostOrDeleteData } from '@/utils/code'
import { deleteOrder, getTravelOrderList, modifyTravelsOrderById } from '@/api/order/order'
import ModifyOrder from '@/components/common/modifyOrder/index'
import DeleteOrder from '@/components/common/deleteOrder/deleteOrder'
import ModifyCost from '@/components/common/modifyCost/modifyCost'
import UserInfo from '@/components/common/user/userInfo'
import Sendmail from '@/components/common/sendmail/index'

import uploadPdf from '@/components/common/uploadPdf/index'
import Pagination from '@/components/common/Pagination/index'
import SearchInput from '@/components/common/searchInput/searchInput'

export default {
  components: { SearchInput, ModifyCost, DeleteOrder, Pagination, ModifyOrder, UserInfo, Sendmail, uploadPdf },
  data() {
    return {
      activeName: 'CONFIRM',
      // 查询参数
      queryInfo: {
        current: 1,
        size: 20,
        keyword: '',
        status: 'CONFIRM'
      },
      orderList: [],
      total: 0,
      dialogVisible: false,
      valList: [],
      dialogVisibleDecidedOrder: false,
      dialogPlayBallTime: false,
      playBallTime: {},
      courtTime: []
    }
  },
  created() {
    this.handleQuery()
  },
  watch: {
    courtTime: {
      handler(newValue) {
        this.courtTime = newValue
      },
      immediate: true,
      deep: true
    },

    queryInfo(newData) {
      this.activeName = newData.status === '' ? 'ALL' : newData.status
    }
  },

  methods: {
    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },

    //查询列表
    getOrderList(page, cb) {
      getTravelOrderList(page).then((res) => {
        let list = cb(res)
        list.forEach((r) => {
          r.courtTime = JSON.parse(r.courtTime)
          r.groupPerson = JSON.parse(r.groupPerson)
          if (r.groupPerson) {
            r.groupPerson.forEach((r) => {
              let names = []
              r.data.forEach((v) => {
                names.push(v.name)
              })
              r.names = names.join('-').toString()
            })
          }
        })
        this.orderList = list ? list : []
      })
    },

    //确定订单
    decidedOrder(row) {
      this.$refs.sendmail.editDialog(row)
    },
    openPlayTime(row) {
      this.dialogPlayBallTime = true
      this.playBallTime = JSON.parse(JSON.stringify(row))
      let ctJson = JSON.parse(JSON.stringify(this.playBallTime.courtTime))
      ctJson.forEach((res) => {
        res.startTime = res.concreteTime.split(' - ')[0]
        res.endTime = res.concreteTime.split(' - ')[1] ? res.concreteTime.split(' - ')[1] : ''
      })
      this.courtTime = JSON.parse(JSON.stringify(ctJson))
    },

    modifyStadiumOrder() {
      //解析打球时间
      let ct = []
      this.courtTime.forEach(d => {
        let obj = {
          concreteTime: d.endTime ? `${d.startTime} - ${d.endTime}` : d.startTime,
          key: d.key,
          date: d.date
        }
        ct.push(obj)
      })
      let confirmEnterDate = this.playBallTime.confirmEnterDate
      let confirmOutDate = this.playBallTime.confirmOutDate
      let data = {
        confirmEnterDate: confirmEnterDate ? confirmEnterDate : null,
        confirmOutDate: confirmOutDate ? confirmOutDate : null,
        courtTime: JSON.stringify(ct)
      }
      modifyTravelsOrderById(data, this.playBallTime.orderId).then(res => {
        let data = getData(res)
        if (data != null) {
          this.$message.success('修改成功!')
          this.dialogPlayBallTime = false
          this.handleQuery()
        }
      })
    },

    openOrder(row) {
      this.$refs.modifyOrder.editDialog(row, 'TRAVEL')
    },

    //按钮状态
    btnStatus(val) {
      this.queryInfo.status = val.name === 'ALL' ? '' : val.name
      this.handleQuery()
    },

    //查看打球人
    lookDiamond(val) {
      this.valList = val
      this.dialogVisible = true
    },

    //根据ID删除数据
    removeOrderById(id) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteOrder(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.handleQuery()
          }
        })
      }).catch(() => {
      })
    },

    //修改
    editOrder(row) {
      this.$refs.editOrder.editDialog(row)
    },

    //查看下单用户信息
    getUserInfoByOrder(row) {
      this.$refs.getUserInfo.getUserInfo(row.userInfo)
    },
    //修改订单
    updateTravelOrder(row) {
      localStorage.setItem(row.orderId, JSON.stringify(row))
      this.$router.push({
        path: '/updateTravelOrder',
        query: {
          id: row.orderId
        }
      })
    },
    //上传PDF
    uploadPdf(row) {
      this.$refs.uploadPdf.editDialog(row.orderId)
    }

  }
}
</script>

<style lang='less' scoped>
/deep/ .el-dialog {
  padding-right: 30px;
}

/deep/ .plo {
  font-size: 18px;
  margin-bottom: 10px;

  span {
    margin-right: 10px;
  }
}
</style>
